// The form's attachments: what the row already has, the drop zone, and the files in flight.
//
// Existing attachments are listed by name and size with a delete for the owner; queued, uploading
// and failed files show their state beneath the zone. A failed file keeps its reason until it is
// removed - it is the one thing on the form the BD must read before leaving.

import { ALLOWED_CONTENT_TYPES } from '../../documents/files.js';
import Icon from '../../ui/Icon.jsx';
import DropZone from '../../ui/DropZone.jsx';
import { STATES, formatBytes } from './uploads.js';

const STATE_LABEL = {
  [STATES.queued]: 'Waiting',
  [STATES.uploading]: 'Uploading…',
  [STATES.done]: 'Uploaded',
  [STATES.failed]: 'Failed',
};

export default function AttachmentUploader({
  existing, items, draining, onFiles, onRemove, onDelete, creating,
}) {
  return (
    <section className="attachments" aria-labelledby="attachments-heading">
      <h3 id="attachments-heading">Attachments</h3>

      <DropZone accept={ALLOWED_CONTENT_TYPES.join(',')} onFiles={onFiles} disabled={draining}
                hint="PDF, JPEG or PNG · up to 25 MB each">
        Drop files here, or choose them
      </DropZone>

      {creating && items.length > 0 && (
        <p className="hint">Uploaded when the row is saved.</p>
      )}

      {(existing.length > 0 || items.length > 0) && (
        <ul className="attachment-list">
          {existing.map((attachment) => (
            <li key={attachment.attachment_id}>
              <span className="attachment-name">
                <strong>{attachment.filename}</strong>
                <small>{formatBytes(attachment.size_bytes ?? 0)} · {attachment.uploaded_by}</small>
              </span>
              {onDelete && (
                <button type="button" className="icon-button quiet"
                        onClick={() => onDelete(attachment)}
                        aria-label={`Remove ${attachment.filename}`} title="Remove">
                  <Icon name="trash" />
                </button>
              )}
            </li>
          ))}
          {items.map((item) => (
            <li key={item.key} className={`pending ${item.state}`}>
              <span className="attachment-name">
                <strong>{item.file.name}</strong>
                <small>
                  {formatBytes(item.file.size)} · {STATE_LABEL[item.state]}
                  {item.error && <span className="error"> — {item.error}</span>}
                </small>
              </span>
              {item.state !== STATES.uploading && (
                <button type="button" className="icon-button quiet"
                        onClick={() => onRemove(item.key)}
                        aria-label={`Remove ${item.file.name}`} title="Remove">
                  <Icon name="close" />
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
